module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp23_2.f9646152.png";